import React, { Fragment } from "react";
import { Image } from "primereact/image";
import ChangePassword from "./change-password.component";
import LOGO from "../../assets/images/thumb_SA.png";
import { Container, WelcomeContainer } from "./settings.styles";

const Settings = () => {
  return (
    <Fragment>
      <Container>
        <WelcomeContainer>
          <div className='k-w-100pct k-text-center'>
            <Image src={LOGO} />
          </div>
        </WelcomeContainer>
        <ChangePassword />
      </Container>
    </Fragment>
  );
};

export default Settings;
